import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { Div, StyledUtilsProps } from '../helpers/StyledUtils';
interface ClickableRowProps extends StyledUtilsProps {
  to: string;
  children: ReactNode;
}
interface ClickableRowContentProps extends StyledUtilsProps {
  children: ReactNode;
}
const StyledContent = styled(Div)`
  pointer-events: none;

  &:hover {
    position: relative;
    z-index: 2;
  }
`;
const StyledClickableRowWrapper = styled(Div)`
  position: relative;

  &:hover {
    ${StyledContent} {
      position: relative;
      z-index: 2;
    }
  }

  > a:first-child {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    text-decoration: none;
    color: transparent;

    &:hover {
      background-color: ${({
  theme
}) => theme.colors.surface.base.hover.neutral};
      cursor: pointer;
    }

    &:focus-visible {
      background-color: ${({
  theme
}) => theme.colors.surface.base.hover.neutral};
      outline: none;
    }
  }

  /* Only show hover when not hovering over Content components */
  &:hover:has([data-clickable-row-content]:hover) > a:first-child {
    background-color: transparent;
    cursor: default;
  }
`;
const StyledClickableRowContent = styled(Div)`
  pointer-events: auto;
  width: fit-content;
`;
const ClickableRowContent: React.FC<ClickableRowContentProps> = t0 => {
  const $ = _c(6);
  let children;
  let styledProps;
  if ($[0] !== t0) {
    ({
      children,
      ...styledProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = styledProps;
  } else {
    children = $[1];
    styledProps = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== styledProps) {
    t1 = <StyledClickableRowContent data-clickable-row-content={true} {...styledProps}>{children}</StyledClickableRowContent>;
    $[3] = children;
    $[4] = styledProps;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const ClickableRow: React.FC<ClickableRowProps> & {
  Content: typeof ClickableRowContent;
} = t0 => {
  const $ = _c(12);
  let children;
  let styledProps;
  let to;
  if ($[0] !== t0) {
    ({
      to,
      children,
      ...styledProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = styledProps;
    $[3] = to;
  } else {
    children = $[1];
    styledProps = $[2];
    to = $[3];
  }
  let t1;
  if ($[4] !== to) {
    t1 = <RouterLink to={to} />;
    $[4] = to;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== styledProps) {
    t2 = <StyledContent {...styledProps}>{children}</StyledContent>;
    $[6] = children;
    $[7] = styledProps;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <StyledClickableRowWrapper>{t1}{t2}</StyledClickableRowWrapper>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
ClickableRow.Content = ClickableRowContent;
export default ClickableRow;